<template>
  <div class="home">
    <a href="https://qpic.jp/" id="logo_home">
      <img src="@/assets/qpic_logo.svg" />
    </a>
    <transition
      enter-active-class="animated fadeInRight"
      leave-active-class="animated fadeOut"
      mode="out-in"
      class="fastest"
      appear
    >
      <Building
        linkURL="/music"
        :lightImgSrc="musicLightImgSrc"
        :darkImgSrc="musicDarkImgSrc"
        :darkImgOffset="-1"
        class="music"
      ></Building>
    </transition>
    <transition
      enter-active-class="animated fadeInLeft"
      leave-active-class="animated fadeOut"
      mode="out-in"
      class="fastest"
      appear
    >
      <Building
        linkURL="/graphic"
        :lightImgSrc="graphicLightImgSrc"
        :darkImgSrc="graphicDarkImgSrc"
        :darkImgOffset="-10"
        class="graphic"
      ></Building>
    </transition>
    <transition
      enter-active-class="animated fadeInRight"
      leave-active-class="animated fadeOut"
      mode="out-in"
      class="fastest"
      appear
    >
      <Building
        linkURL="/story"
        :lightImgSrc="storyLightImgSrc"
        :darkImgSrc="storyDarkImgSrc"
        :darkImgOffset="0"
        class="story"
      ></Building>
    </transition>
    <transition
      enter-active-class="animated fadeInLeft"
      leave-active-class="animated fadeOut"
      mode="out-in"
      class="fastest"
      appear
    >
      <Building
        linkURL="/game"
        :lightImgSrc="gameLightImgSrc"
        :darkImgSrc="gameDarkImgSrc"
        :darkImgOffset="0"
        class="game"
      ></Building>
    </transition>
  </div>
</template>

<script>
import Building from "@/components/Building.vue";
import musicLightImgSrc from "@/assets/main_music_l720.png";
import musicDarkImgSrc from "@/assets/main_music_d720.png";
import graphicLightImgSrc from "@/assets/main_graphic_l720.png";
import graphicDarkImgSrc from "@/assets/main_graphic_d720.png";
import storyLightImgSrc from "@/assets/main_story_l720.png";
import storyDarkImgSrc from "@/assets/main_story_d720.png";
import gameLightImgSrc from "@/assets/main_game_l720.png";
import gameDarkImgSrc from "@/assets/main_game_d720.png";

// @ is an alias to /src
export default {
  name: "Home",
  components: {
    Building,
  },
  data() {
    return {
      musicLightImgSrc: musicLightImgSrc,
      musicDarkImgSrc: musicDarkImgSrc,
      graphicLightImgSrc: graphicLightImgSrc,
      graphicDarkImgSrc: graphicDarkImgSrc,
      storyLightImgSrc: storyLightImgSrc,
      storyDarkImgSrc: storyDarkImgSrc,
      gameLightImgSrc: gameLightImgSrc,
      gameDarkImgSrc: gameDarkImgSrc,
    };
  },
};
</script>
<style scoped lang="scss">
.home {
  &::before {
    content: "";
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: 50% 100%;
    background-image: url("../assets/bgmain.png");
    background-size: cover;
  }
}
#logo_home {
  position: fixed;
  right: 2%;
  top: 80px;
  width: 20%;
  @media (max-width: 1000px) {
    width: 30%;
  }
  img {
    width: 100%;
  }
}
.game {
  position: fixed;
  top: 40%;
  left: 5%;
  width: 25%;
  @media (max-width: 1000px) {
    width: 30%;
    left: 5%;
    top: 52%;
  }
}
.graphic {
  position: fixed;
  top: 22%;
  left: 25%;
  width: 25%;
  @media (max-width: 1000px) {
    width: 30%;
    left: 18%;
    top: 42%;
  }
}
.music {
  position: fixed;
  top: 25%;
  right: 22%;
  width: 25%;
  @media (max-width: 1000px) {
    width: 30%;
    right: 20%;
    top: 40%;
  }
}
.story {
  position: fixed;
  top: 40%;
  right: 5%;
  width: 25%;
  @media (max-width: 1000px) {
    width: 30%;
    right: 5%;
    top: 48%;
  }
}
</style>
